import { useQuery } from "@tanstack/react-query";
import { Integration } from "../../types";
import { integrationService } from "../../services/integrationService";

export const useIntegrations = () => {
  return useQuery<Integration[]>({
    queryKey: ["integrations"],
    queryFn: async () => integrationService.list(),
  });
};


